import { render, staticRenderFns } from "./MMP_UpdateAccessRole.vue?vue&type=template&id=56deab22&scoped=true&"
import script from "./MMP_UpdateAccessRole.vue?vue&type=script&lang=js&"
export * from "./MMP_UpdateAccessRole.vue?vue&type=script&lang=js&"
import style0 from "./MMP_UpdateAccessRole.vue?vue&type=style&index=0&id=56deab22&prod&scoped=true&lang=css&"
import style1 from "./MMP_UpdateAccessRole.vue?vue&type=style&index=1&id=56deab22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56deab22",
  null
  
)

export default component.exports